<template>
  <v-dialog scrollable persistent
    class="dialog"
    v-model="config.status.active"
    max-width="600px">
    <v-card>
      <v-card-title class="primary blue-grey--text text--darken-4">
        <span class="headline">新規顧客の追加</span>
      </v-card-title>
      <v-card-text>
        <v-form lazy-validation
          ref="form"
          v-model="form.valid">
          <v-row dense>
            <v-col cols="12" sm="6" class="px-2">
              <v-text-field ref="firstInput"
                label="姓"
                v-model="form.name[0]"
                counter="10"
                :rules="rules.name"
              />
            </v-col>
            <v-col cols="12" sm="6" class="px-2">
              <v-text-field
                label="名"
                v-model="form.name[1]"
                counter="10"
                :rules="rules.name"
              />
            </v-col>
            <v-col cols="12" sm="6" class="px-2">
              <v-text-field
                label="せい"
                v-model="form.kana[0]"
                counter="10"
                :rules="rules.kana"
              />
            </v-col>
            <v-col cols="12" sm="6" class="px-2">
              <v-text-field
                label="めい"
                v-model="form.kana[1]"
                counter="10"
                :rules="rules.kana"
              />
            </v-col>
            <v-col cols="12" class="px-2">
              <v-select
                label="担当"
                v-model="form.author"
                :items="getConsultantItems"
                :rules="rules.required"
              />
            </v-col>
          </v-row>
          <v-progress-linear v-if="isSearching" indeterminate color="secondary"></v-progress-linear>
          <v-row dense v-if="getClientItems.length">
            <v-col cols="12">
              <v-checkbox
                v-model="form.confirm"
                color="secondary"
                :label="`類似した顧客：${getClientItems.length}人を確認`"
                :rules="rules.required"
              />
            </v-col>
          </v-row>
          <v-list dense v-if="getClientItems.length">
            <template v-for="item in getClientItems">
              <v-list-item :key="item.id">
                <v-list-item-content>
                  <v-list-item-subtitle class="caption">{{ item.kana ? item.kana.replace(',', ' ') : '' }}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.name ? item.name.replace(',', ' ') : '' }}</v-list-item-title>
                  <v-list-item-subtitle class="caption"><span class="font-weight-bold">担当：</span>{{ meta.authors[item.aid] ? meta.authors[item.aid].name[0] : item.author }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="`${item.id}_div`"></v-divider>
            </template>
          </v-list>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text
          color="secondary"
          @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed
          color="secondary"
          @click.stop="insert"
          :loading="isLoading"
          :disabled="!isValid || isLoading">登録する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash'
const DEFAULT = {
  CONFIG: {
    PAGE: 'form'
  }
}
export default {
  name: 'insert-modal',
  components: {
  },
  props: [
  ],
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          initializing: false
        },
        page: DEFAULT.CONFIG.PAGE
      },
      meta: {
        authors: []
      },
      rules: {
        required: [
          v => !!v || '必須項目です'
        ],
        name: [
          v => !!v || '必須項目です'
        ],
        kana: [
          v => !!v || '必須項目です',
          v => !/[^ぁ-ん]/.test(v) || '平仮名のみ入力有効です'
        ]
      },
      store: {
        authors: [],
        clients: []
      },
      form: {
        valid: true,
        kana: ['', ''],
        name: ['', ''],
        author: ''
      }
    }
  },
  created: function () {
  },
  mounted: function () {
  },
  methods: {
    init: function (req) {
      const { kana, name, author } = req || {
        kana: ['', ''],
        name: ['', ''],
        author: ''
      }
      this.$set(this, 'form', {
        valid: true,
        confirm: false,
        kana: [ kana[0] || '', kana[1] || ''],
        name: [ name[0] || '', name[1] || ''],
        author: author || ''
      })
      this.$set(this.store, 'clients', [])
      this.$nextTick(() => {
        this.$nextTick(this.$refs.firstInput.focus)
      })
    },
    emitted: function (req) {
      const { dest, action, data } = req || {}
      if (dest) {
        if (action && this.$refs[dest] && typeof this.$refs[dest][action] === 'function') {
          this.$refs[req.dest][req.action](req.data)
        }
      } else {
        if (action && typeof this[action] === 'function') {
          this[action](data)
        }
      }
    },
    insert: function () {
      this.submit({ type: 'insert' })
    },
    preSubmit: function (req) {
      const { type } = req
      const { kana, name, author } = this.form
      const search = kana.join('') || name.join('') || ''
      const urls = {
        client: `${this.$url.api}/client/get/items`,
        insert: `${this.$url.api}/clients/insert/item/withbox`
      }
      const fds = {
        client: { name: search },
        insert: {
          name: name.map(name => name.trim()).join(','),
          kana: kana.map(kana => kana.trim()).join(','),
          author
        }
      }
      if (type && urls[type] && fds[type]) {
        if (type === 'insert' && this.$refs.form.validate()) {
          this.$set(this.config.status, 'loading', true)
          return { type, url: urls[type], fd: fds[type] }
        } else if (type === 'client' && search) {
          this.$set(this.config.status, 'searching', true)
          return { type, url: urls[type], fd: fds[type] }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { type, url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({
                type,
                data: res.data.data
              })
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req) {
      const { type, data } = req || {}
      if (type === 'client') {
        this.$set(this.config.status, 'searching', false)
        this.$set(this.form, 'confirm', false)
        this.$set(this.store, 'clients', data)
      } else if (type === 'insert') {
        this.$set(this.config.status, 'loading', false)
        this.$emit('done')
        this.close()
      }
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
    },
    page: function (req) {
      if (req && req.name) {
        this.$set(this.config, 'page', req.name)
        this.$nextTick(() => {
          if (req.name === 'confirm' && req.form) {
            this.$refs.confirm.init(req.form)
          }
        })
      }
    },
    searchClient: _.debounce(function (val) {
      this.submit({ type: 'client' })
    }, 300),
    done: function () {
      this.$emit('done')
      this.close()
    },
    open: function () {
      this.$set(this.config.status, 'active', true)
      this.init()
      this.$emit('open')
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  watch: {
    'form.name': function (val) {
      if (val.join('') && !this.config.status.searching) {
        this.searchClient()
      }
    },
    'form.kana': function (val) {
      if (val.join('') && !this.config.status.searching) {
        this.searchClient()
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    getStatus () {
      return this.config.status
    },
    currentPage () {
      return this.config.page
    },
    getClientItems () {
      return this.store.clients.length ? this.store.clients : []
    },
    getConsultantItems () {
      const authors = this.$store.getters['config/get']('authors')
      const keys = Object.keys(authors)
      return keys.length ? keys.filter(key => {
        return authors[key].roles.includes('consultant')
      }).map(key => {
        return {
          text: authors[key].name[0] || key,
          value: key
        }
      }) : []
    }
  }
}
</script>
